import i18next from 'i18next';
import type { ReadCallback, Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
/**
 * Keep i18next as a global instance, but don't initialise until we have init arguments for
 * namespace and language.
 */
const i18nInstance = i18next.use(initReactI18next);

/**
 * This function retrieves the global instance of i18n.
 *
 * @returns {i18n} The corresponding i18n instance.
 *
 * @example
 * const i18nInstance = getGlobali18nInstance();
 */
export function getGlobali18nInstance() {
  return i18nInstance;
}

interface Options {
  locale?: string;
  namespace: string[];
  importFn: (
    language: string,
    namespace: string,
    callback: ReadCallback
  ) => void;
  resources?: Resource;
  supportedLngs?: string[];
}

export async function initTranslations({
  locale = 'en',
  namespace,
  importFn,
  resources,
  supportedLngs,
}: Options) {
  if (!i18nInstance.isInitialized) {
    await i18nInstance.use(resourcesToBackend(importFn)).init({
      partialBundledLanguages: true,
      // Temporary preload `en` until we get 100% of the app translated
      preload: ['en'],
      // The fallback language is loaded on initialisation in addition to any other language set.
      fallbackLng: 'en',
      ns: ['web', 'statementGlossary'],
      defaultNS: namespace,
      supportedLngs,
      lng: locale,
      react: {
        useSuspense: false,
      },
      resources,
    });
  }

  return i18nInstance;
}
